import { useEffect, useRef, useState } from 'react';

export function useWebSocket({ token, onMessage }) {
    const [status, setStatus] = useState('disconnected');
    const [socket, setSocket] = useState(null);
    const onMessageRef = useRef(onMessage);
    onMessageRef.current = onMessage;

    useEffect(() => {
        let disposed = false;
        let activeSocket;
        let reconnectTimer;
        let heartbeat;
        let delay = 1000;
        setSocket(null);
        if (!token) {
            setStatus('disconnected');
            return;
        }
        const connect = () => {
            if (disposed) return;
            setStatus('connecting');
            const ws = new WebSocket('wss://api.tbot.co.in/ws', [`token-${token}`]);
            activeSocket = ws;
            ws.onopen = () => {
                if (disposed) { ws.close(); return; }
                setSocket(ws);
                setStatus('connected');
                delay = 1000;
                heartbeat = setInterval(() => {
                    if (ws.readyState === WebSocket.OPEN) ws.send('ping');
                }, 10000);
            };
            ws.onmessage = event => {
                if (!disposed && event.data !== 'pong') onMessageRef.current?.(event.data);
            };
            ws.onclose = () => {
                clearInterval(heartbeat);
                if (disposed) return;
                setSocket(null);
                setStatus('reconnecting');
                reconnectTimer = setTimeout(connect, delay);
                delay = Math.min(delay * 2, 30000);
            };
            ws.onerror = () => ws.close();
        };
        connect();
        return () => {
            disposed = true;
            clearTimeout(reconnectTimer);
            clearInterval(heartbeat);
            activeSocket?.close();
        };
    }, [token]);

    return { socket, status };
}
